<template>
  <div class='mainContainer'>
    <div class='nav'>
      <div class='navContainer' style='width: 210px'>
        <p>托运商：</p>
        <el-input v-model='entrustIpt' size='mini' style='width:150px' placeholder='请输入委托商名称' />
      </div>
      <div class='navContainer' style='width: 230px'>
        <p>扣款原由：</p>
        <el-input v-model='reasonIpt' size='mini' style='width:150px' placeholder='请输入扣款原由' />
      </div>
      <div class='navContainer' style='width: 400px'>
        <p>违反时间：</p>
        <el-date-picker v-model='timeIpt[0]' size='mini' style='width:150px'
                        value-format='yyyy-MM-dd' @change='dateChange' type='date'
                        placeholder='开始日期' />
        <span style='display:inline-block;width:15px;text-align:center;font-size:18px'>-</span>
        <el-date-picker v-model='timeIpt[1]' size='mini' style='width:150px'
                        value-format='yyyy-MM-dd' @change='dateChange' type='date'
                        placeholder='结束日期' />
      </div>
      <div class='navContainer'>
        <p>状态：</p>
        <el-select v-model='stateIpt' size='mini' style='width:150px' filterable placeholder='请选择'>
          <el-option v-for='item in stateOption' :key='item.value' :label='item.label'
                     :value='item.value' />
        </el-select>
      </div>
      <div class='navBtn'>
        <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
        <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
      </div>
    </div>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          v-loading='tableLoad'
          :data='TableDatas'
          style='width: 100%'
          border
          stripe
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label='序号' align='center' width='50px' type='index' />
          <el-table-column prop='supplierName' label='托运商' align='center' />
          <el-table-column prop='deductionReasonDesc' label='扣款原由' align='center' />
          <el-table-column prop='deduction' label='扣款金额(元)' width='199' align='center' />
          <el-table-column prop='createTime' label='违反时间' align='center' />
          <el-table-column prop='examine' label='审核状态' align='center' width='100%'>
            <div slot-scope='scope'>{{ getState(scope.row.examine, scope.row.operationPower) }}
            </div>
          </el-table-column>
          <el-table-column prop='examine' label='操作类型' align='center' width='100%'>
            <div slot-scope='scope'>{{ operationTypeFormat(scope.row.operationType) }}</div>
          </el-table-column>
          <el-table-column label='操作' width='205' align='center'>
            <template slot-scope='scope'>
              <div style='display:flex;align-items:center;padding-left: 10px'>
                <el-button size='mini' class='searchBtn' type='primary'
                           @click='detailClick(scope.row.id,scope.scope.row.operationPower)'>详情
                </el-button>
                <el-button v-if='scope.row.examine===1 && scope.row.operationPower===1' size='mini'
                           type='primary' @click='enableClick(scope.row.id)'>同意
                </el-button>
                <el-button v-if='scope.row.examine===1 && scope.row.operationPower===1'
                           type='danger' @click='disableClick(scope.row.id)'>拒绝
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <span>共{{ total }}条</span>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='sizes,prev, pager, next,jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          @prev-click='contractCurrentChange'
          @next-click='contractCurrentChange'
        />
      </div>
    </div>
    <el-dialog title='详情托运商日常考核' :visible.sync='detailDialogVisible' width='600px' center top='10vh'
               :close-on-click-modal='false'>
      <div class='detail'>
        <div class='baseInfo'>
          <div class='baseInfoTitle'>
            <div class='line' />
            <span>基础信息</span>
            <p :style='getStyle(detailData.state)'>{{ detailData.stateStr }}</p>
          </div>
          <div class='baseInfoContent'>
            <div class='baseInfoContentItem'>
              <span class='span1'>委托商名称：</span>
              <span>{{ detailData.supplierName }}</span>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>扣款金额：</span>
              <span>{{ detailData.deduction }}</span>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>扣款原因：</span>
              <span>{{ detailData.deductionReasonDesc }}</span>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>详情原因：</span>
              <span>{{ detailData.deductionReasonDetail }}</span>
            </div>
          </div>
        </div>
        <div class='baseInfo'>
          <div class='baseInfoTitle'>
            <div class='line' />
            <span>附件信息</span>
          </div>
          <div class='baseInfoContent' style='padding: 0 23px 10px 23px;'>
            <div style='display: flex;width: 100%' v-if='detailData.img && detailData.img.length>0'>
              <el-form :model='detailData' label-position='left' style='width: 100%'>
                <span
                  style='font-weight: 700;margin: 10px 10px;cursor: pointer;display: block;width: 150px;text-decoration: underline'>查看附件人</span>
                <el-row :gutter='10' style='width: 100%' v-for='(item,index) in detailData.img'
                        :key='`${index}cvg`'>
                  <el-col :span='13'
                          style='white-space: nowrap;overflow: hidden;text-overflow: ellipsis;'>
                    {{ item.name }}
                  </el-col>
                  <el-col :span='7'>{{ item.uploadTime }}</el-col>
                  <el-col :span='2'>
                    <i class='el-icon-zoom-in' @click='handlePictureCardPreview(item,index)'
                       v-if="item.name.substring(item.name.indexOf('.')) == '.jpeg'
                             ||item.name.substring(item.name.indexOf('.')) == '.png'
                             ||item.name.substring(item.name.indexOf('.')) == '.jpg'
                             || item.name.substring(item.name.indexOf('.')) == '.gif'"></i>

                  </el-col>
                  <el-col :span='2'>
                    <i class='el-icon-download' @click='downloadClick(item.id)'></i>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <div v-else
                 style='font-weight: 700;margin: 10px 10px;cursor: pointer;display: block;width: 150px;'>
              暂无权限
            </div>
          </div>
        </div>
        <div class='baseInfo'>
          <div class='baseInfoTitle'>
            <div class='line' />
            <span>审核信息</span>
          </div>
          <steps :step-data='stepData' :step-state='stepState' />
        </div>
        <div class='baseInfo' v-if='detailData.operationPower===1 && detailData.examine ===1'>
          <div class='baseInfoTitle'>
            <div class='line' />
            <span>操作</span>
          </div>
          <div class='baseInfoContentItem'>
            <div style='display: flex;margin:10px 20px 0 15px;'>
              <span class='span1' style='width: 70px;'><span style='color:red'>*</span>原因：</span>
              <el-input
                type='textarea'
                :style="'width:100%'"
                v-model='remark'
                placeholder='请填写同意/拒绝原因'
                autocomplete='off'
                size='small'
              />
            </div>
          </div>
        </div>
        <div style='display: flex;align-items: center;justify-content: center'
             v-if='detailData.operationPower===1 && detailData.examine ===1'>
          <el-button size='medium' type='primary' @click='agreeClick'>同意</el-button>
          <el-button size='medium' type='danger' @click='refusedClick'>拒绝</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title='reasonTitle' :visible.sync='reasonVisible' width='550px' center
               :close-on-click-modal='false' top='30vh'>
      <div class='reasonContainer'>
        <div style='display: flex;padding-bottom: 20px;'>
          <span class='span1' style='width: 70px;'><span style='color:red'>*</span>原因：</span>
          <el-input
            type='textarea'
            style='width:100%;'
            v-model='reason'
            :placeholder='`请填写${reasonTitle}`'
            autocomplete='off'
            size='small'
          />
        </div>
        <div class='reasonBtn'>
          <el-button size='medium' class='searchBtn' type='primary' @click='reasonClick'>确认
          </el-button>
          <el-button size='medium' class='resetBtn' type='danger' @click='reasonVisible=false'>取消
          </el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync='dialogVisible' append-to-body title='图片查看' center>
      <img width='100%' :src='dialogImageUrl' alt=''>
    </el-dialog>
  </div>
</template>

<script>
  import steps from '@/components/steps';
  import {
    dailyReviewAuditPageList,
    dailyReviewReviewSubmit,
    dailyReviewDetail,
  } from '@/service/audit';
  import { baseImgUrl, baseUrl } from '@/config/env';
  import { getSessionStore } from '@/config/mUtils';

  export default {
    components: {
      steps,
    },
    data() {
      return {
        entrustIpt: '',
        reasonIpt: '',
        timeIpt: ['', ''],
        stateIpt: '',
        stateOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 1,
            label: '待审核',
          },
          {
            value: 2,
            label: '已通过',
          },
          {
            value: 3,
            label: '已拒绝',
          },
          {
            value: 4,
            label: '已取消',
          },
        ],
        page: 1,
        size: 10,
        total: 0,
        tableLoad: false,
        TableDatas: [],
        detailDialogVisible: false,
        baseImgUrl: baseImgUrl + '/',
        detailData: {
          img: [],
        },
        remark: '',
        stepData: [
          {
            title: '张三发起',
            time: '2021-9-30 14:09:23',
            state: '',
            remark: '',
          },
          {
            title: '财务部 张三通过',
            time: '2021-9-30 14:09:23',
            state: 'success',
            remark: '原因xxxxxx',
          },
          {
            title: '技术部 李四拒绝',
            time: '2021-9-30 14:09:23',
            state: 'failure',
            remark: '原因xxxxxx',
          },
          {
            title: '张三重新发起',
            time: '2021-9-30 14:09:23',
            state: '',
            remark: '',
          },
        ],
        reasonVisible: false,
        reasonTitle: '',
        reason: '',
        activeId: '',
        dialogVisible: false,//图片查看显示
        dialogImageUrl: '',//图片路径
      };
    },
    computed: {
      stepState() {
        return function(state) {
          switch (state) {
            case '':
              return 'wait';
            case 'success':
              return 'success';
            case 'failure':
              return 'error';
          }
        };
      },
      getStyle() {
        return (val) => {
          switch (val) {
            case 2:
              return 'color: rgba(51, 136, 255, 1);';
            case 1:
              return 'color: rgba(249, 166, 6, 1)';
            case 3:
              return 'color:#F56C6C;';
            case 4:
              return 'color:#F56C6C;';
          }
        };
      },
      // 审核状态
      getState() {
        return function(state, operationPower) {
          switch (true) {
            case operationPower === 0:
              return '已通过';
            case state === 1 && operationPower === 1:
              return '待审核';
            case state === 2 && operationPower === 1:
              return '已通过';
            case state === 3 && operationPower === 1:
              return '已拒绝';
            case state === 4 && operationPower === 1:
              return '已取消';
          }
        };
      },
      //操作类型
      operationTypeFormat() {
        return function(value) {
          switch (value) {
            case 1:
              return '新增';
            case 2:
              return '信息变更';
            case 3:
              return '终止合作';
          }
        };
      },
    },
    mounted() {
      this._dailyReviewAuditPageList();
    },
    methods: {
      async _dailyReviewAuditPageList() {
        this.tableLoad = true;
        const res = await dailyReviewAuditPageList(
          {
            supplierName: this.entrustIpt,
            deductionReasonDesc: this.reasonIpt,
            state: this.stateIpt,
            startTime: this.timeIpt[0] ? this.timeIpt[0] : '',
            endTime: this.timeIpt[1] ? this.timeIpt[1] : '',
            rows: this.size,
            page: this.page,
          },
        );
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.TableDatas = res.data.records;
        this.total = res.data.total;
      },
      // 结束时间
      dateChange(val) {
        if (this.timeIpt[1] && this.timeIpt[0] && (this.timeIpt[1] <= this.timeIpt[0])) {
          if (val == this.timeIpt[1]) this.timeIpt[1] = '';
          if (val == this.timeIpt[0]) this.timeIpt[0] = '';
          this.$forceUpdate();
          return this.$message.warning('结束日期必须大于开始日期！');
        }
      },
      async refusedClick() {
        this.remark = this.remark.trim();
        if (!this.remark) return this.$message.warning('请填写拒绝理由！');
        const res = await dailyReviewReviewSubmit({
          id: this.activeId,
          reviewResult: 'REFUSE',
          auditOpinion: this.remark,
        });
        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        this.detailDialogVisible = false;
        await this._dailyReviewAuditPageList();
      },
      async agreeClick() {
        this.remark = this.remark.trim();
        if (!this.remark) return this.$message.warning('请填写同意理由！');
        const res = await dailyReviewReviewSubmit({
          id: this.activeId,
          reviewResult: 'AGREE',
          auditOpinion: this.remark,
        });
        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        this.detailDialogVisible = false;
        await this._dailyReviewAuditPageList();
      },
      contractSizeChange(sizes) {
        this.size = sizes;
        0;
        this._dailyReviewAuditPageList();
      },
      contractCurrentChange(page) {
        this.page = page;
        this._dailyReviewAuditPageList();
      },
      disableClick(id) {
        this.$confirm('确认拒绝当前委托商申请吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.activeId = id;
            this.reason = '';
            this.reasonTitle = '拒绝原因';
            this.reasonVisible = true;
          })
          .catch(() => {
          });
      },
      /**
       * 详情
       * @param id
       * @param operationPower 权限
       * @returns {Promise<ElMessageComponent>}
       */
      async detailClick(id, operationPower) {
        this.activeId = id;
        this.remark = '';
        this.detailDialogVisible = true;
        const res = await dailyReviewDetail({ id });
        if (res.status !== 0) return this.$message.error(res.message);
        this.detailData = {
          ...res.data,
          img: res.data.attachmentList.map(item => {
            return {
              name: item.attachmentName,
              url: this.baseImgUrl + item.attachmentGroup + '/' + item.attachmentPath,
              status: 'success',
              id: item.id,
              uploadTime: item.uploadTime,
            };
          }),
          operationPower: operationPower,
        };
      },
      searchBtn() {
        this.page = 1;
        this._dailyReviewAuditPageList();
      },
      resetBtn() {
        this.entrustIpt = '';
        this.reasonIpt = '';
        this.timeIpt = ['', ''];
        this.stateIpt = '';
      },
      enableClick(id) {
        this.$confirm('确认同意当前委托商申请吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.activeId = id;
            this.reason = '';
            this.reasonTitle = '同意原因';
            this.reasonVisible = true;
          })
          .catch(() => {
          });
      },
      async reasonClick() {
        this.reason = this.reason.trim();
        if (!this.reason) return this.$message.warning(this.reasonTitle === '同意原因' ? '请填写同意原因！' : '请填写拒绝原因!');
        const res = await dailyReviewReviewSubmit({
          id: this.activeId,
          reviewResult: this.reasonTitle === '同意原因' ? 'AGREE' : 'REFUSE',
          auditOpinion: this.remark,
        });
        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        this.reasonVisible = false;
        await this._dailyReviewAuditPageList();
      },
      /**
       * 详情图片查看
       * @param item 图片对象
       * @param index 循环索引
       */
      handlePictureCardPreview(item, index) {
        let token = getSessionStore('token');
        this.dialogImageUrl = baseImgUrl + '/web/attachmentFtp/download?attachmentId=' + (item.id || item.response.data.id) + '&access_token=' + token;
        this.dialogVisible = true;
      },
      //详情附件下载
      downloadClick(id) {
        let token = getSessionStore('token');
        window.location.href = baseUrl + '/web/attachmentFtp/download?attachmentId=' + id + '&access_token=' +
          token;
      },
    },
  };
</script>


<style lang='scss' scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 25px;

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .tableContainer {
        margin-top: 30px;
        margin-bottom: 25px;
        width: 100%;

        ::v-deep {
          .el-badge__content {
            top: 4px !important;
            right: 1px !important;
          }

          .el-badge__content {
            background-color: #F56C6C !important;
          }

          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;
      max-height: 80vh;
      overflow: auto;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          &Item {
            margin-bottom: 20px;

            .imgContainer {
              display: flex;
              align-items: center;
            }

            .span1 {
              font-weight: 700;
            }

            span {
              font-size: 14px;
            }

            .specialOne {
              width: 50%;
            }
          }

          .specialItem {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        ::v-deep {
          .el-table td, .el-table th {
            padding: 0;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;
        }
      }
    }

    .reasonContainer {
      width: 100%;
      padding: 20px 30px;

      ::v-deep {
        .el-textarea__inner {
          min-height: 100px !important;
        }
      }

      .reasonBtn {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }

    .company {
      width: 100%;
      padding: 20px 10px;

      ::v-deep {
        .el-form-item__label {
          font-weight: 700;
        }

        .el-input__inner {
          border: none;
        }

        .el-form-item__label {
          padding: 0;
        }

        .el-form-item__content {
          position: relative;
        }
      }

      hr {
        margin: 0;
        position: absolute;
        width: 100%;
        bottom: 5px;
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {
      .el-table th > .cell {
        font-weight: 700 !important;
      }
    }
  }

  ::v-deep {
    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
    }
  }
</style>
